import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './RelatedVideos.css';
import {TSupportVideos} from '../../../redux/management/management.type';
import VideoIcon from '../../../assets/icons/Video';
import Plus from '../../../assets/icons/Plus';

interface RelatedVideosProps {
    videos: TSupportVideos[];
    onSelect?: (video: TSupportVideos) => void;
}

function RelatedVideos({videos, onSelect}: RelatedVideosProps) {
    const {t} = useTranslation('layout');
    const [showAll, setShowAll] = useState(false);

    if (videos.length === 0) return null;

    const displayedVideos = showAll ? videos : videos.slice(0, 8);

    return (
        <css.relatedSection>
            <css.relatedTitle>{t('moreGuides')}</css.relatedTitle>
            <css.relatedChips>
                {displayedVideos.map((video) => (
                    <Button 
                        key={video.id}
                        variant="primary"
                        size="chip"
                        onClick={() => onSelect?.(video)}
                        iconEnd={<VideoIcon />}
                    >
                        {video.title}
                    </Button>
                ))}
                {!showAll && videos.length > 8 && (
                    <Button
                        variant="subtle"
                        size="chip"
                        onClick={() => setShowAll(true)}
                        iconEnd={<Plus />}
                    >
                        {t('showAll')}
                    </Button>
                )}
            </css.relatedChips>
        </css.relatedSection>
    );
}

export default RelatedVideos;
